import cookieReader from 'cookies-js';
import Radio from 'backbone.radio';
import {router} from './router';
import {BasicLayout} from '../shared/view/BasicLayout/BasicLayout';
import {ResourceLocator} from './resources/ResourceLocator';
import * as SessionObjects from './resources/SessionObjects';
import {GIGYA} from './resources/SessionObjects';

/**
 * @class DFApp
 * @extends Mn.Application
 *
 * @property {Backbone.Radio}    routerChannel
 * @property {Mn.Region} content
 * @property {Mn.Region} modal
 */
class DFApp extends Mn.Application {

    onStart () {

        this.setHttpErrorHandlers();
        this.setHttpSecurityOptions();

        /**
         * Injecting basic layout into the page
         */
        let layout = new BasicLayout({
            model: this.getResourceLocator()
        });
        this.showView(layout);

        /**
         * Injecting Staging panel if not on production
         * TODO: remove that part to use fm channel in Staging panel
         */
        if (_.includes(['local', 'develop', 'qa', 'staging'], ENV)) {
            import('../shared/view/StagingPanel/StagingPanel.js').then(({StagingPanel}) => {
                layout.showChildView('staging', new StagingPanel({router}));
            });
        }

        Radio.channel('fm').reply('get:sessObj', function (sessObjName) {

            return SessionObjects[sessObjName];
        });

        /**
         * Start application listening for URL changes
         */
        router.start();
    }

    onLogout (isRedirect) {

        SessionObjects.CURRENT_USER.logout();
        SessionObjects.expire();

        let redirectUrl = '/login';
        let lastRouteEvent = router.getLastEvent();

        if ((isRedirect === true) && lastRouteEvent && lastRouteEvent.fragment) {

            let fragment = `/${lastRouteEvent.fragment}`;
            let path = fragment.replace(router.getLocalePrefix(), '');

            if (path) {
                redirectUrl = `${redirectUrl}?redirect=${path}`
            }
        }

        router.navigateRelativelyToLocaleCode(redirectUrl);
    }

    getResourceLocator () {

        if (!this.resources) {

            this.resources = new ResourceLocator();
        }

        return this.resources;
    }

    /**
     * Will set necessary security and non-caching headers for API.
     * @param {string} dfToken
     */
    setHttpSecurityOptions (dfToken) {

        jQuery.ajaxPrefilter((options) => {

            // Encode and ensure double encoding does not happen
            if (options.url) {
                options.url = encodeURI(decodeURI(options.url));
            }

            if(options.ignoreSecurityOptions){
                return;
            }

            /**
             * Setting up the security token.
             * Should be send with every API call.
             */
            let token = dfToken || cookieReader(SECURITY_TOKEN_NAME);

            if (!token) {

                if (window.ENV === 'local') {
                    // because of security concept and gigya api calls this does not work
                    // token = SECURITY_TOKEN_DEV_VALUE;
                }
                else {
                    console.warn('NOT SECURITY TOKEN PROVIDED');
                }
            }

            options.headers = options.headers || {};

            // Headers should not be added for onesoil API for CORS to work
            if (options.url.startsWith(ONESOIL_API_HOST)) {
                return;
            }

            if(token){
                options.headers[SECURITY_TOKEN_NAME] = token;
            }

            /**
             * Prevent caching of API calls.
             * Especially for IE.
             */
            if (!options.headers['If-Modified-Since']) {
                options.headers['If-Modified-Since'] = 'Thu, 01 Jan 1970 01:00:00 GMT';
            }

            if (!options.headers['Cache-control']) {
                options.headers['Cache-control'] = 'no-cache';
            }

            if (!options.headers['Pragma']) {
                options.headers['Pragma'] = 'no-cache';
            }
        });
    }

    setHttpErrorHandlers () {

        jQuery(document).ajaxError((errObj, jqXHR, ajaxSettings, errMessage) => {

            let httpCodesToIgnore = ajaxSettings.headers ? ajaxSettings.headers['IGNORE_HTTP_ERROR'] : '',
                statusCode = jqXHR.status;

            if (_.includes(httpCodesToIgnore, statusCode)) {

                // If code is provided in corresponding header it will be handled on higher level in the app
                return;
            }

            switch (statusCode) {

                case 401:
                    // 1. Log out the user
                    // 2. Clear all session objects
                    // 3. Redirect to login page
                    this.onLogout(true);
                    break;

                case 403:
                    // 1. Log out the user
                    // 2. Clear all session objects
                    // 3. Redirect to login page
                    SessionObjects.expire();
                    router.navigateRelativelyToLocaleCode('/error-403', {trigger: true});
                    break;

                case 500:
                case 400:

                    Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                        content: __('SMTH_WRONG')
                    });

                    console.warn(`SERVER ERROR ( ${statusCode} ): ${errMessage}`);
                    break;
            }
        });
    }
}

let app = new DFApp({
    region: '#page-cnt'
});

export {app};



// WEBPACK FOOTER //
// ./js/app.js